/**
 * Mobile menu toggle
 *
 * @class
 */
export default class MobileToggle {

    /**
     * Constructor
     *
     * @param  {Element} btn
     * @param  {Element} container
     */
    constructor (btn, container) {
        this.addEventListeners(btn, container);
    }


    /**
     * addEventListeners
     *
     * @param  {Element} btn
     * @param  {Element} container
     */
    addEventListeners (btn, container) {
        btn.addEventListener('click', (e) => {
            if (!container.classList.contains('is-active')) {
                container.classList.add('is-active');
                document.body.classList.add('is-inactive');
            } else {
                container.classList.remove('is-active');
                document.body.classList.remove('is-inactive');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./lib/mobile-toggle.js